export const customTheme = {
  fontFamily: "DM Sans",
  background: "#F3F3F3",
  screen: {
    width: 500,
    padding: 2,
  },
};
